export default class Footer {
    constructor() {
        this.init();
    }

    init() {
        // Create footer element
        const footer = document.createElement('footer');
        footer.className = 'footer';

        footer.innerHTML = `
            <div class="footer-content">
                <div class="footer-left">
                    <p class="footer-tagline">Transformons vos idées en créations visuelles</p>
                    <p class="footer-contact-text">Pour toute demande d'information ou de devis, vous pouvez me contacter à l'adresse e-mail ci-dessous.</p>
                    <a href="mailto:maxencelasserrepro@gmail.com" class="footer-email">
                        maxencelasserrepro@gmail.com
                    </a>
                    <p class="footer-phone" style="margin-top:10px;">+33 7 81 43 85 75</p>
                    <p class="footer-copyright">© ${new Date().getFullYear()} Ceathair. Tous droits réservés.</p>
                </div>
                <img src="/Images/footer-logo.png" alt="Ceathair Logo" class="footer-logo">
            </div>
        `;

        // Append to body
        document.body.appendChild(footer);
    }
}
